import { Http } from '@/lib/http';

export class DelinquencyCaseAssignmentService extends Http {
  constructor() {
    super();
    this.endpoint = 'delinquency-pro/app/external-case-assignments';
  }

  /**
   * 
   * @param {Can be case id or external participant id} id 
   * @returns Array of assignments
   */
  findExternalCaseAssignments(id, page, limit, sort, order) {
    const queryString = [`idOrExternalParticipantId=${id}`]
    if(page) {
      queryString.push(`page=${page}`)
    }
    if(limit) {
      queryString.push(`limit=${limit}`)
    }
    if(sort) {
      queryString.push(`sort=${sort}`)
    }
    if(order) {
      queryString.push(`order=${order}`)
    }
    return this.httpClient().get(`${this.endpoint}?${queryString.join('&')}`);
  }

  /**
 * @param {Object} information
 * @param {string} assignmentId
 */
  updateDelinquencyCaseAssignment(assignmentId, information) {
    return this.httpClient().put(`${this.endpoint}/${assignmentId}`, information);
  }

  /**
   * @param {Object} payload - The filter object that contains information for the assignment.
   * @param {string} payload.loanCaseId - The id of the loan.
   * @param {string} payload.externalParticipantId - The id of the external participant.
   * @param {Object} payload.information
   */
  assignExternalCase(payload) {
    return this.httpClient().post(`${this.endpoint}`, payload);
  }

  /**
   * @param {Array} ids - An array of all the case ids to unassign.
   */
  unAssignExternalCaseAssignments(ids) {
    return this.httpClient().patch(`${this.endpoint}/deassign`, ids);
  }

  /**
   * 
   * @param {String} externalParticipantId 
   * @returns 
   */
  fetchExternalCaseAssignmentReport(externalParticipantId) {
    try {
      return this.httpClient().get(`/delinquency-pro/app/external-participant-management/external-case-assignment-report/${externalParticipantId}`)
    } catch (error) {
      console.log(error);
      Logger.error('Getting foreclosure case external assignments');
    }
  }

  fetchLoanCases(page, limit) {
    try {
      const queryString = [];
      if(page) { queryString.push(`page=${page}`) }
      if(limit) { queryString.push(`limit=${limit}`) }

      return this.httpClient().get(`/delinquency-pro/app/external-participant-management/loan-case?${queryString.join('&')}`)
    } catch (error) {
      console.log(error);
      Logger.error('Getting loan cases');
    }
  } 

  /**
   * 
   * @param {String} externalParticipantId 
   * @returns 
   */
  fetchChargedOffLoanExternalCaseAssignmentReport(externalParticipantId) {
    try {
      return this.httpClient().get(`/delinquency-pro/app/external-participant-management/charged-off-case-assignment-report/${externalParticipantId}`)
    } catch (error) {
      console.log(error);
      Logger.error('Getting external charged off case assignment');
    }
  }

}